function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Percentage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17",
    height: "16",
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M2.5603 14.0231c-.5858-.5858-.5858-1.5356 0-2.1213L12.886 1.5761c.5858-.5858 1.5355-.5858 2.1213 0 .5858.5857.5858 1.5355 0 2.1213L4.6816 14.023c-.5858.5858-1.5356.5858-2.1213 0Z",
    fill: "#BFF6F8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2395 1.9296 2.9138 12.2553c-.3905.3905-.3905 1.0237 0 1.4142.3905.3905 1.0237.3905 1.4142 0L14.6537 3.3438c.3906-.3905.3906-1.0237 0-1.4142-.3905-.3905-1.0236-.3905-1.4142 0ZM2.5603 11.9018c-.5858.5857-.5858 1.5355 0 2.1213.5857.5858 1.5355.5858 2.1213 0L15.0073 3.6974c.5858-.5858.5858-1.5356 0-2.1214-.5858-.5857-1.5355-.5857-2.1213 0L2.5603 11.9018Z",
    fill: "#528693"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.984 3.4998c0 1.3807-1.1193 2.5-2.5 2.5s-2.5-1.1193-2.5-2.5 1.1193-2.5 2.5-2.5 2.5 1.1193 2.5 2.5Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.484 5.4998c1.1045 0 2-.8955 2-2 0-1.1046-.8955-2-2-2-1.1046 0-2 .8954-2 2 0 1.1045.8954 2 2 2Zm0 .5c1.3807 0 2.5-1.1193 2.5-2.5s-1.1193-2.5-2.5-2.5-2.5 1.1193-2.5 2.5 1.1193 2.5 2.5 2.5Z",
    fill: "#528693"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.984 12.4998c0 1.3807-1.1193 2.5-2.5 2.5s-2.5-1.1193-2.5-2.5 1.1193-2.5 2.5-2.5 2.5 1.1193 2.5 2.5Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.484 14.4998c1.1045 0 2-.8955 2-2 0-1.1046-.8955-2-2-2-1.1046 0-2 .8954-2 2 0 1.1045.8954 2 2 2Zm0 .5c1.3807 0 2.5-1.1193 2.5-2.5s-1.1193-2.5-2.5-2.5-2.5 1.1193-2.5 2.5 1.1193 2.5 2.5 2.5Z",
    fill: "#528693"
  }));
}

export default Percentage;